export enum BudgetRecipient {
    CONSULTANT = "CONSULTANT",
    TOWER = "FACTORY",
    MANAGER = "MANAGER",
  }